/**
 * SiteRererrer(OTA)関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */

const OptionState = {
  label: null,
  value: null
}

export default OptionState
